export default "__VITE_ASSET__BngqrtZ7__"